import React, { useEffect, useState } from "react";
import "./ProfileStyle.css";
import ProgressBar from "../../components/globalComponents/progressBar/ProgressBar";
import PrimaryButton from "../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import TextField from "../../components/globalComponents/textFields/TextField";
import Dropdown from "../../components/globalComponents/dropdown/Dropdown";
import CustomDatePicker from "../../components/globalComponents/customDatePicker/CustomDatePicker";
import TextArea from "../../components/globalComponents/textArea/TextArea";
import { useSelector, useDispatch } from "react-redux";
import {
  userSliceFunction,
  getStudentDetails,
  updateStudentDetails,
} from "../../reducers/userSlice";
import PageLoader from "../../components/globalComponents/PageLoader/PageLoader";

const Profile = () => {
  const { isFetching, studentData } = useSelector(userSliceFunction);
  const dispatch = useDispatch();

  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [aboutMe, setAboutMe] = useState("");

  const [mobileNumber, setMobileNumber] = useState(studentData?.mobileNumber);
  const [address, setAddress] = useState("");

  useEffect(() => {
    dispatch(getStudentDetails());
    // eslint-disable-next-line
  }, []);

  const basicInfoSubmit = () => {
    let obj = {
      dob: dob,
      gender: gender,
      aboutMe: aboutMe,
    };
    dispatch(updateStudentDetails(obj));
  };
  const contactInfoSubmit = () => {
    let obj = {
      mobileNumber: mobileNumber,
      address: address,
    };
    dispatch(updateStudentDetails(obj));
  };

  return (
    <>
      {isFetching && <PageLoader />}
      <div className="pageHeader">
        <div></div>
        <div className="pageTogglers">
          <div className="pageToggler active">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99995 3.125C8.27406 3.125 6.87495 4.52411 6.87495 6.25C6.87495 7.97589 8.27406 9.375 9.99995 9.375C11.7258 9.375 13.125 7.97589 13.125 6.25C13.125 4.52411 11.7258 3.125 9.99995 3.125ZM5.62495 6.25C5.62495 3.83375 7.58371 1.875 9.99995 1.875C12.4162 1.875 14.375 3.83375 14.375 6.25C14.375 8.66625 12.4162 10.625 9.99995 10.625C7.58371 10.625 5.62495 8.66625 5.62495 6.25ZM7.79744 12.2916C7.83663 12.2917 7.87635 12.2917 7.91662 12.2917H12.0833C12.1235 12.2917 12.1633 12.2917 12.2025 12.2916C13.2509 12.2914 13.9191 12.2913 14.4823 12.4621C15.7474 12.8459 16.7374 13.8359 17.1212 15.1009C17.292 15.6641 17.2919 16.3324 17.2916 17.3808C17.2916 17.42 17.2916 17.4597 17.2916 17.5C17.2916 17.8452 17.0118 18.125 16.6666 18.125C16.3214 18.125 16.0416 17.8452 16.0416 17.5C16.0416 16.2916 16.0348 15.8259 15.925 15.4638C15.6624 14.5982 14.9851 13.9209 14.1195 13.6583C13.7574 13.5484 13.2917 13.5417 12.0833 13.5417H7.91662C6.70818 13.5417 6.24251 13.5484 5.88043 13.6583C5.01484 13.9209 4.33748 14.5982 4.07491 15.4638C3.96507 15.8259 3.95829 16.2916 3.95829 17.5C3.95829 17.8452 3.67846 18.125 3.33329 18.125C2.98811 18.125 2.70829 17.8452 2.70829 17.5C2.70829 17.4597 2.70828 17.42 2.70827 17.3808C2.70804 16.3324 2.70789 15.6641 2.87873 15.1009C3.26249 13.8359 4.25249 12.8459 5.51757 12.4621C6.08077 12.2913 6.74902 12.2914 7.79744 12.2916Z"
                fill="#262626"
              />
            </svg>
            Profile
          </div>
        </div>
        <div></div>
      </div>
      <div className="profileContainerOuter">
        <div className="profileContainer">
          <div className="profileLeft">
            <div className="profileProgressBox">
              <div className="userProfile">
                <img
                  src="https://images.pexels.com/photos/4473796/pexels-photo-4473796.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=600"
                  alt=""
                  class="userImg"
                />
                <p className="name">{`${studentData?.firstName} ${studentData?.lastName}`}</p>
              </div>
              <div className="progressContent">
                <p>Profile Progress</p>
                <p>30%</p>
              </div>
              <ProgressBar width={"52%"} color={"var(--success-4)"} />
            </div>
            <div className="hrLine"></div>
            <div className="proflieTabs">
              <div className="profileTab active">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.33345 3.125C6.60756 3.125 5.20845 4.52411 5.20845 6.25C5.20845 7.97589 6.60756 9.375 8.33345 9.375C10.0593 9.375 11.4584 7.97589 11.4584 6.25C11.4584 4.52411 10.0593 3.125 8.33345 3.125ZM3.95845 6.25C3.95845 3.83375 5.9172 1.875 8.33345 1.875C10.7497 1.875 12.7084 3.83375 12.7084 6.25C12.7084 8.66625 10.7497 10.625 8.33345 10.625C5.9172 10.625 3.95845 8.66625 3.95845 6.25ZM15.1832 8.51639C16.0026 7.69701 17.331 7.697 18.1504 8.51636C18.9698 9.33574 18.9698 10.6643 18.1504 11.4836L12.7697 16.8643C12.7638 16.8702 12.7579 16.8761 12.7519 16.8821C12.679 16.9552 12.6009 17.0335 12.5099 17.1003C12.4304 17.1587 12.3451 17.2089 12.2554 17.25C12.1528 17.2971 12.0465 17.3274 11.9471 17.3556C11.939 17.358 11.931 17.3602 11.9229 17.3625L9.33848 18.101C9.12024 18.1633 8.88534 18.1024 8.72484 17.9419C8.56434 17.7814 8.50347 17.5465 8.56583 17.3283L9.30425 14.7438C9.30653 14.7358 9.30882 14.7278 9.31113 14.7197C9.33939 14.6203 9.36966 14.514 9.41675 14.4114C9.45793 14.3217 9.5081 14.2364 9.5665 14.1569C9.63329 14.0659 9.71159 13.9878 9.78471 13.9148C9.79067 13.9089 9.7966 13.903 9.80248 13.8971L15.1832 8.51639ZM17.2665 9.40026C16.9353 9.06904 16.3983 9.06905 16.0671 9.40027L10.6864 14.781C10.6384 14.829 10.6119 14.8555 10.5924 14.8763C10.5754 14.8942 10.5729 14.8983 10.5741 14.8966C10.5658 14.908 10.5586 14.9202 10.5527 14.933C10.5536 14.9311 10.5513 14.9353 10.5438 14.9588C10.5352 14.9859 10.5248 15.022 10.5062 15.0872L10.0768 16.59L11.5795 16.1606C11.6448 16.142 11.6808 16.1316 11.708 16.123C11.7315 16.1155 11.7357 16.1132 11.7338 16.114C11.7466 16.1082 11.7588 16.101 11.7702 16.0927C11.7685 16.0939 11.7725 16.0913 11.7905 16.0744C11.8113 16.0549 11.8378 16.0284 11.8858 15.9804L17.2665 10.5998C17.5978 10.2685 17.5978 9.73149 17.2665 9.40026ZM6.13094 12.2916C6.17013 12.2917 6.20985 12.2917 6.25012 12.2917H7.50012C7.84529 12.2917 8.12512 12.5715 8.12512 12.9167C8.12512 13.2618 7.84529 13.5417 7.50012 13.5417H6.25012C5.04168 13.5417 4.57601 13.5485 4.21393 13.6583C3.34834 13.9209 2.67098 14.5982 2.4084 15.4638C2.29857 15.8259 2.29178 16.2916 2.29178 17.5C2.29178 17.8452 2.01196 18.125 1.66678 18.125C1.3216 18.125 1.04178 17.8452 1.04178 17.5C1.04178 17.4597 1.04177 17.42 1.04176 17.3808C1.04153 16.3324 1.04138 15.6641 1.21223 15.101C1.59599 13.8359 2.58598 12.8459 3.85107 12.4621C4.41426 12.2913 5.08251 12.2914 6.13094 12.2916Z"
                    fill="#171717"
                  />
                </svg>
                <p>Basic Information</p>
              </div>
              <div className="profileTab">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.64005 2.70898H14.3602C15.0376 2.70898 15.5839 2.70897 16.0264 2.74512C16.4819 2.78234 16.882 2.86097 17.2522 3.04959C17.8402 3.34919 18.3183 3.82726 18.6179 4.41526C18.8034 4.77945 18.8825 5.1726 18.9205 5.61899C18.9629 5.73448 18.9693 5.85816 18.9425 5.97453C18.9585 6.35062 18.9585 6.79085 18.9585 7.30722V12.6941C18.9585 13.3714 18.9585 13.9178 18.9223 14.3602C18.8851 14.8157 18.8065 15.2159 18.6179 15.586C18.3183 16.174 17.8402 16.6521 17.2522 16.9517C16.882 17.1403 16.4819 17.219 16.0264 17.2562C15.5839 17.2923 15.0376 17.2923 14.3602 17.2923H5.64003C4.96267 17.2923 4.41633 17.2923 3.97391 17.2562C3.51838 17.219 3.11826 17.1403 2.74808 16.9517C2.16008 16.6521 1.68201 16.174 1.38241 15.586C1.19379 15.2159 1.11516 14.8157 1.07794 14.3602C1.04179 13.9178 1.0418 13.3714 1.0418 12.6941V7.30723C1.0418 6.79086 1.04179 6.35063 1.0578 5.97454C1.03099 5.85816 1.0374 5.73447 1.07978 5.61899C1.11773 5.1726 1.19685 4.77945 1.38241 4.41526C1.68201 3.82726 2.16007 3.34919 2.74808 3.04959C3.11826 2.86097 3.51838 2.78234 3.97391 2.74512C4.41634 2.70897 4.96268 2.70898 5.64005 2.70898ZM2.29193 7.03448C2.29181 7.1299 2.2918 7.22962 2.2918 7.33399V12.6673C2.2918 13.2057 2.29208 13.6204 2.30593 13.9575L6.61801 10.0627L2.29193 7.03448ZM7.96643 9.48082L2.34413 5.54521C2.37737 5.28451 2.42813 5.11629 2.49616 4.98275C2.67593 4.62995 2.96277 4.34311 3.31557 4.16335C3.48017 4.07948 3.69747 4.02187 4.0757 3.99097C4.46123 3.95947 4.95642 3.95898 5.6668 3.95898H14.3335C15.0438 3.95898 15.539 3.95947 15.9246 3.99097C16.3028 4.02187 16.5201 4.07948 16.6847 4.16335C17.0375 4.34311 17.3243 4.62995 17.5041 4.98275C17.5721 5.11629 17.6229 5.28451 17.6561 5.54521L12.0339 9.4808C12.0266 9.48564 12.0195 9.49065 12.0124 9.49582L11.171 10.0848C10.5776 10.5002 10.4122 10.6037 10.2521 10.6436C10.0866 10.6849 9.91362 10.6849 9.74819 10.6436C9.58804 10.6037 9.42265 10.5002 8.82931 10.0848L7.98785 9.49581C7.98079 9.49065 7.97365 9.48565 7.96643 9.48082ZM7.66864 10.7982L2.67745 15.3064C2.84688 15.5279 3.06453 15.71 3.31557 15.838C3.48017 15.9218 3.69747 15.9794 4.0757 16.0103C4.46123 16.0418 4.95642 16.0423 5.6668 16.0423H14.3335C15.0438 16.0423 15.539 16.0418 15.9246 16.0103C16.3028 15.9794 16.5201 15.9218 16.6847 15.838C16.9357 15.71 17.1534 15.5279 17.3228 15.3064L12.3316 10.7982L11.8878 11.1089C11.8595 11.1287 11.8315 11.1483 11.8039 11.1676C11.3361 11.4958 10.9691 11.7531 10.5544 11.8565C10.1905 11.9472 9.80981 11.9472 9.44586 11.8565C9.03115 11.7531 8.66422 11.4958 8.19634 11.1677C8.16875 11.1483 8.14081 11.1287 8.11249 11.1089L7.66864 10.7982ZM13.3823 10.0627L17.6943 13.9575C17.7082 13.6204 17.7085 13.2057 17.7085 12.6673V7.33399C17.7085 7.22962 17.7085 7.1299 17.7083 7.03448L13.3823 10.0627Z"
                    fill="#171717"
                  />
                </svg>
                <p>Contact & Location</p>
              </div>
            </div>
          </div>
          <div className="profileRight">
            <div className="profileRightContainer">
              <img
                src="https://images.pexels.com/photos/4473796/pexels-photo-4473796.jpeg?auto=compress&cs=tinysrgb&w=600"
                alt=""
              />
              <div className="profileRightContent">
                <div className="profileHeader">
                  <p className="name">{`${studentData?.firstName} ${studentData?.lastName}`}</p>
                  <p className="successTag">
                    {studentData?.ProgramDetail?.Program?.programName}
                  </p>
                  <p className="primaryTag">
                    {studentData?.ProgramDetail?.name}
                  </p>
                </div>
                <p className="userText">
                  Futures Trading involves trading in contracts in the
                  derivatives markets. This module covers the various
                  intricacies involved in undergoing.
                </p>
              </div>
            </div>
            <div className="basicInfomationBox">
              <div className="basicInfoHeader">
                <p className="heading">Basic Information</p>
                <PrimaryButton
                  classname={"secondaryBtn"}
                  children={"Save"}
                  onClick={basicInfoSubmit}
                />
              </div>
              <div className="form">
                <div className="udateUserImg">
                  {/* <img src="https://images.pexels.com/photos/4473796/pexels-photo-4473796.jpeg?auto=compress&cs=tinysrgb&w=600" alt="" className="updateUserImg" /> */}
                </div>
                <TextField
                  labelName={"First Name"}
                  value={studentData?.firstName}
                  inputType={"text"}
                  placeholder={"Enter your First Name"}
                  isImportant={true}
                  disabled
                />
                <TextField
                  labelName={"Last Name"}
                  value={studentData?.lastName}
                  inputType={"text"}
                  placeholder={"Enter your Last Name"}
                  isImportant={true}
                  disabled
                />
                <CustomDatePicker
                  label={"Date of Birth"}
                  isImportant={true}
                  value={dob}
                  onChange={(e) => setDob(e)}
                />
                <Dropdown label={"Gender"} isImportant={true} />
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option>Select Gender</option>
                  <option value={"Male"}>Male</option>
                  <option value={"Female"}>Female</option>
                </select>
                <TextArea
                  value={aboutMe}
                  onChange={(e) => setAboutMe(e.target.value)}
                  labelName={"About Me "}
                  placeholder={
                    "I am a budding UX/UI Designer. Having an experience of more than 2 years and worked on various UX/UI design project."
                  }
                />
              </div>
            </div>
            <div className="basicInfomationBox">
              <div className="basicInfoHeader">
                <p className="heading">Contact & Location</p>
                <PrimaryButton
                  classname={"secondaryBtn"}
                  children={"Submit"}
                  onClick={contactInfoSubmit}
                />
              </div>
              <div className="form">
                <TextField
                  labelName={"Email"}
                  value={studentData?.officialEmail}
                  inputType={"email"}
                  placeholder={"Enter your Email"}
                  isImportant={true}
                  disabled
                />
                <TextField
                  labelName={"Mobile Number"}
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  inputType={"number"}
                  placeholder={"Enter your mobile number"}
                  isImportant={true}
                />
                <TextArea
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  labelName={"Address"}
                  placeholder={"Enter Your Address"}
                />
                {/* <Dropdown label={'State'} isImportant={true} />
                                <Dropdown label={'District'} isImportant={true} />
                                <Dropdown label={'City'} isImportant={true} /> */}
                {/* <TextField labelName={'Address'} inputType={'text'} placeholder={'Enter your Flat No.'} isImportant={true} /> */}
                {/* <TextField labelName={''} inputType={'text'} placeholder={'Enter Your Street Name'} />
                                <TextField labelName={''} inputType={'text'} placeholder={'Enter your Area'} />
                                <TextField labelName={''} inputType={'text'} placeholder={'Enter your Pincode'} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
